import { Share2 } from "lucide-react";

export default function ShareButton({ title, when, time, image, testid, className = "" }) {
  const share = (e) => {
    e.stopPropagation();
    const lines = [`✨ ${title} — Afrodite Club Privé & Spa Naturista`, when && `📅 ${when}`, time && `🕙 ${time}`, image && `📷 ${image}`, `🔗 ${window.location.origin}`].filter(Boolean);
    window.open(`https://wa.me/?text=${encodeURIComponent(lines.join("\n"))}`, "_blank", "noopener,noreferrer");
  };
  return (
    <button onClick={share} data-testid={testid} type="button"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#25D366]/40 text-[#25D366] text-xs hover:bg-[#25D366] hover:text-black transition-colors ${className}`}>
      <Share2 className="w-3.5 h-3.5" /> Condividi
    </button>
  );
}
